import { useCallback } from 'react';
import { useNotify } from 'react-admin';

export function useFailureNotify() {
  const notify = useNotify();

  return useCallback(error => notify(error.body.exception || error.body.message), [notify]);
}
